import { Box } from '@mui/material'
import { useFeatureFlag, SPLITS } from '@/helpers/useFeatureFlag'

import React from 'react'

import VendorFilterSort from './sort-mui'

import { tagGroupNames, VendorSearchState } from '../../states/useVendorSearchState'

type Props = {
  filters: VendorSearchState['filters']
  search: VendorSearchState['search']
}

const SupplierSort: React.FC<Props> = ({ search, filters }) => {
  const countrySpecificFiltersFlagOn = useFeatureFlag(SPLITS.COUNTRY_SPECIFIC_FILTERS_GM)
  const showDiversityTags = useFeatureFlag(SPLITS.SHOW_DIVERSITY_TAGS_GM)

  type OrderBy = 'position' | 'label'

  const getOrderBy = (condition: boolean, defaultValue: OrderBy): OrderBy => {
    return condition ? 'position' : defaultValue
  }

  const tagFiltersConfig = [
    {
      tagType: tagGroupNames.Occasion,
      specificToCountry: countrySpecificFiltersFlagOn,
      orderBy: getOrderBy(countrySpecificFiltersFlagOn, 'label'),
    },
    {
      tagType: tagGroupNames.Cuisine,
      specificToCountry: countrySpecificFiltersFlagOn,
      orderBy: 'position' as OrderBy,
    },
    {
      tagType: tagGroupNames.Dietary,
      orderBy: 'label' as OrderBy,
      useName: true,
    },
    {
      tagType: tagGroupNames.KeyDates,
      specificToCountry: countrySpecificFiltersFlagOn,
      orderBy: getOrderBy(countrySpecificFiltersFlagOn, 'label'),
    },
  ]

  if (showDiversityTags) {
    tagFiltersConfig.push({
      tagType: tagGroupNames.DiversityOfOwnership,
      specificToCountry: countrySpecificFiltersFlagOn,
      orderBy: getOrderBy(countrySpecificFiltersFlagOn, 'label'),
    })
  }

  return (
    <Box>
      <VendorFilterSort filters={filters} search={search} />
    </Box>
  )
}

export default SupplierSort
